export const getFacebookShareLink = (link: string) => {
  return `https://www.facebook.com/sharer/sharer.php?u=${link}`;
};
